export default __webpack_public_path__ + "static/media/menu1.657f4be6.svg";